import axios from '@lib/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export interface Data {
  lists: string[];
	onlySave?: boolean;
}

interface Props {
  contentId?: string;
	onSuccess?: (onlySave: boolean) => void;
  onError?: (res: AxiosError) => void;
}

export const useSetListsToContent = ({
  contentId,
	onSuccess,
  onError
}: Props) => {
	const queryClient = useQueryClient();
  const {
		mutate: onSetListsToContent,
		variables,
		...rest
	} = useMutation({
		mutationFn: async ({ lists: listIds }: Data) => axios.post(`/contents/${contentId}/lists`, { listIds }),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['content', contentId] });
			if (onSuccess)
				onSuccess(!!variables?.onlySave);
		},
    onError
	});

	return { onSetListsToContent, variables, ...rest };
};
